<template>
    <button @click="toggleMenu" id="menuToggle"
        class="md2:hidden text-gray-500 w-20 h-full relative focus:outline-none dark:text-white">
        <span class="sr-only">{{ $t('Open main menu') }}</span>
        <div class="block w-5 absolute left-1/2 top-1/2   transform  -translate-x-1/2 -translate-y-1/2 pointer-events-none">
            <span aria-hidden="true"
                class="block absolute h-0.5 w-5 bg-current transform transition duration-500 ease-in-out"
                :class="{ 'rotate-45': open, ' -translate-y-1.5': !open }"></span>
            <span aria-hidden="true"
                class="block absolute  h-0.5 w-5 bg-current   transform transition duration-500 ease-in-out"
                :class="{ 'opacity-0': open }"></span>
            <span aria-hidden="true"
                class="block absolute  h-0.5 w-5 bg-current transform  transition duration-500 ease-in-out"
                :class="{ '-rotate-45': open, ' translate-y-1.5': !open }"></span>
        </div>
    </button>
</template>
  
<script>
export default {
    data() {
        return {
            open: false,
            bigger_show: false,
        }
    },
    mounted() {
        this.$root.$on("collapsedMenu", (msg) => {
            this.bigger_show = msg;
        });
    },
    methods: {
        toggleMenu(e) {
            this.$root.$emit("showMenu", !this.open);
            this.open = !this.open;
            if (this.open) {
                $("body").addClass("menu_open")
                $("body").addClass("scroll_lock")
            } else {
                $("body").removeClass("menu_open")
                $("body").removeClass("scroll_lock")
            }
        }
    }
};
</script>
  